<template>
  <div class="news-page">
    <LayoutDefault>
      <TheToolbar
        @click-plus="goToEditor(0)"
        @click-trash="deleteNews"
        @click-copy="cloneNews"
        :selected-row-table="selectedRowTableId"
        buttons
      />
      <ListTableEducation
        :data="dataSource"
        :policies="cutPolicies(policies, 'Articles')"
        @row-selected="onRowSelect"
        @redirect-to-editor="goToEditor"
        @row-edit="onRowEditSave"
      />
    </LayoutDefault>
  </div>
</template>

<script>
import { onMounted, computed, ref } from 'vue'
import { useStore } from 'vuex'
import router from '@/router'

import LayoutDefault from '@/layout/LayoutDefault.vue'
import TheToolbar from '@/components/blocks/TheToolbar.vue'
import ListTableEducation from '@/components/blocks/ListTableEducation.vue'

import { cutPolicies } from '@/helpers/policiesValidator.js'

export default {
  name: 'NewsEducationView',
  components: {
    LayoutDefault,
    ListTableEducation,
    TheToolbar
  },
  setup () {
    const store = useStore()

    onMounted(() => {
      // запрашиваем данные при монтировании компонента
      store.dispatch('setNewsEducationDataTable')
    })

    // эти данные возможно нужно будет поменять под права на учебный сайт
    const policies = computed(() => store.getters.getPolicies)

    const dataSource = computed(() => {
      // данные для отрисовки таблицы
      return store.getters.getNewsEducationDataTable
    })

    const selectedRowTableId = ref(0) // id товара по выбранной строке в таблице

    const onRowSelect = (e) => {
      // функция слушает событие выбора строки в таблице
      // получает id товара
      selectedRowTableId.value = e.data.Id
    }

    const goToEditor = (id) => {
      // переход на страницу редактора
      // если передать 0 то пустая форма
      router.push(`/news-education/editor/${id}`)
    }

    const deleteNews = () => {
      // инициирует запрос на удаление новости
      store.dispatch('setDeleteNewsEducation', selectedRowTableId.value)
    }

    const cloneNews = () => {
      // инициирует запрос на клонирование новости
      store.dispatch('setCloneNewsEducation', selectedRowTableId.value)
    }

    const onRowEditSave = (event) => {
      // при редактировании строки таблицы на предмет публикации
      // и готовности к публикации
      const obj = {
        ReadyToPublishStatus: event.newData.ReadyToPublish,
        PublishedStatus: event.newData.Published,
        Id: event.newData.Id
      }
      store.dispatch('setStatusNewsEducationTable', obj)

      // а это чтобы в таблице сразу менялись данные не дожидаясь выполнения запроса
      const { newData, index } = event
      dataSource.value[index] = newData
    }

    return {
      dataSource,
      policies,
      cutPolicies,
      selectedRowTableId,
      onRowSelect,
      goToEditor,
      deleteNews,
      cloneNews,
      onRowEditSave
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
